module.exports = __webpack_public_path__ + "static/media/Golden-Retriever-Head-Shot---Pastel.53f39dc2.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/thumbnails/Golden-Retriever-Head-Shot---Pastel.jpg
 ** module id = 436
 ** module chunks = 0
 **/